module.exports = {
	"hk":{
		"userData.tipsText13":"男",
		"userInfo.formLabel[8]":"會籍狀態",
		"userData.tipsText14":"生日",
		"userData.tipsText15":"常居地",
		"userInfo.datorErrText[5]":"輸入的字符超過25個",
		"userData.tipsText16":"會籍狀態",
		"forgetPassword.password":"密碼",
		"register.rulesPassword":"密碼不能為空",
		"userData.tipsText17":"已啟用",
		"userData.tipsText18":"(已申請刪除)",
		"login.loginName":"賬號",
		"userData.tipsText19":"其他資料",
		"register.placeholderLoginName":"請輸入手機號碼",
		"login.err":"登錄失敗",
		"register.placeholderLoginName2":"請輸入電子郵件地址",
		"register.loading":"註冊中",
		"register.getCodeText":"獲取驗證碼",
		"forgetPassword.doForgetPassword":"確定",
		"userData.tipsText20":"刪除帳戶",
		"userData.tipsText21":"儲存",
		"userData.tipsText22":"更新頭像成功",
		"userInfo.userImgButton":"上傳新頭像",
		"userData.tipsText23":"發生錯誤：",
		"forgetPassword.placeholder3":"請輸入新密碼",
		"userInfo.placeholder[0]":"請輸入居住地",
		"forgetPassword.placeholder4":"請輸入驗證碼",
		"forgetPassword.placeholder2":"請輸入電郵地址",
		"userInfo.formLabel[7]":"常居地",
		"userInfo.serveStatus":"服務狀態",
		"userInfo.datorErrText[4]":"姓名包含特殊字符",
		"register.tipsText9":"私隱條款",
		"register.placeholderPassword2":"再次輸入設定密碼",
		"ui.placeholderPhone":"請輸入手機號碼",
		"register.tipsText8":"服務條款",
		"register.tipsText7":"閣下可同時開通其他服務平台，享受更多服務。",
		"register.tipsText6":"啟動SUPer Card其他服務",
		"register.tipsText5":"本人同意接收有關「SUPer Card」、「{count}」之最新產品資訊、折扣優惠推薦、促銷通訊或任何類似的訊息。",
		"register.tipsText4":"本人同意接收有關「SUPerCard」之最新產品資訊、折扣優惠推薦、促銷通訊或任何類似的訊息。",
		"register.tabText":"手提電話註冊",
		"register.tipsText3":"輸入優惠碼(可選填)",
		"register.tipsText2":"再次輸入設定密碼",
		"forgetPassword.placeholder5":"修改中",
		"register.tipsText1":"輸入設定密碼",
		"userInfo.success":"操作成功",
		"userServe.tipsText1":"啟動SUPer Card其他服務",
		"userServe.tipsText2":"SUPer Card同時提供更多不同服務及優惠，",
		"register.success":"註冊成功",
		"userServe.tipsText3":"經閣下同意後即可啟動",
		"userServe.tipsText4":"已啟動",
		"login.placeholderPassword":"請輸入密碼",
		"userServe.tipsText5":"更改接收優惠資訊設定",
		"userInfo.openServe":"已啟用服務狀態",
		"userServe.tipsText6":"返回",
		"forgetPassword.rulesPassword":"密碼不能為空",
		"ui.getCodeSuccess":"發送成功，請注意查收",
		"userInfo.serveTips9":"驗證碼",
		"userServe.tipsText7":"如欲更改接收狀態請登入",
		"ui.86":"+86 中國內地",
		"register.rulesCheckedItem":"請剔選同意以上條款",
		"userInfo.serveTips8":"請檢查必填項目",
		"userServe.tipsText8":"不可設置當前服務",
		"userInfo.serveTips7":"請上傳圖片",
		"userServe.tipsText9":"此操作將停用該服務,並且登出賬號",
		"userInfo.open":"開",
		"userInfo.serveTips6":"第三方綁定",
		"userInfo.serveTips5":"電郵：",
		"userData.tipsText10":"姓名",
		"userInfo.serveTips4":"如需申請停用帳號，請按以下電郵聯絡我們，我們將有專人處理。",
		"userData.tipsText11":"性別",
		"userInfo.serveTips3":"此操作將停用該服務,並且登出賬號",
		"userData.tipsText12":"女",
		"userInfo.serveTips2":"此操作將啟動該服務",
		"userInfo.formLabel[6]":"生日",
		"register.loginName":"賬號",
		"ui.placeholderCode":"驗證碼",
		"login.loginButtonText":"登入",
		"userInfo.datorErrText[3]":"暱稱包含特殊字符",
		"userInfo.bind":"綁定",
		"err.title":"錯誤提示",
		"register.disableAccount":"停用/刪除會籍",
		"openServiceLogin.tipsText2":"閣下可同時開通其他服務平台，享受更多服務。",
		"openServiceLogin.tipsText1":"啟動{count}服務",
		"deleteAccount.tipsText4":"如帳戶仍有訂單尚未完成，本公司將於所有訂單完成後，處理删除帳戶申請。",
		"deleteAccount.tipsText3":"帳戶內所有資料，包括個人資料、等級、消費累計、優惠券、電子禮券、積分、儲印或其他獎賞將一併删除。",
		"deleteAccount.tipsText2":"帳戶一經删除，帳戶將無法使用及恢復。",
		"deleteAccount.tipsText1":"删除「{count}」帳戶注意事項",
		"register.lastStep":"上一步",
		"deleteAccount.tipsText8":"我已閱讀及了解以上說明",
		"deleteAccount.tipsText7":"本公司將於7-14個工作天內處理閣下的申請。",
		"deleteAccount.tipsText6":"帳戶一經删除，將會自動登出及無法再次登入。",
		"deleteAccount.tipsText5":"申請删除帳戶後，帳戶內未完成的訂單均不能申請退款或換貨。",
		"deleteAccount.tipsText9":"確認申請刪除帳戶",
		"register.nextStop":"下一步",
		"userInfo.formLabel[5]":"電郵地址",
		"userInfo.datorErrText[2]":"最多輸入12個字符",
		"login.tipsText12":"綁定失敗",
		"ui.tipsTitle":"提示",
		"login.tipsText11":"綁定成功",
		"login.tipsText10":"你的賬號未綁定賬號，請先註冊/登入",
		"login.tipsText16":"登入失敗",
		"userInfo.openButton":"現在啟動",
		"login.tipsText15":"登錄成功",
		"login.tipsText14":"請輸入正確的手機號碼",
		"forgetPassword.subTitle":"一本 – 文化閱讀購物平台",
		"login.tipsText13":"當前賬戶未開通該服務，請閱讀及同意以下服務。",
		"login.success":"登錄成功",
		"register.placeholder3":"請再次輸入密碼",
		"register.placeholder2":"請輸入密碼",
		"viewQRCode.closeButton":"關閉",
		"register.placeholder5":"請填寫註冊資料",
		"register.placeholderPassword":"輸入設定密碼",
		"register.placeholder4":"*密碼必須同時包括字母及數字",
		"login.submit":"登錄",
		"login.password":"密碼",
		"userInfo.formLabel[4]":"手機號碼",
		"userInfo.serveEmail":"接收電郵推廣",
		"forgetPassword.rulesCode":"驗證碼不能為空",
		"forgetPassword.placeholder":"請輸入手機號碼",
		"forgetPassword.rulesOldPassword":"舊密碼不能為空",
		"ui.placeholderPhone3":"請輸入正確的手機號碼",
		"ui.placeholderPhone4":"手機號碼不能爲空",
		"ui.placeholderPhone2":"請核對並輸入正確手機號碼",
		"err.appErrText":"訪問出錯，請聯係管理員!",
		"login.title":"SSO登錄",
		"forgetPassword.title":"SSO找回密碼",
		"userInfo.formLabel[3]":"性別",
		"userInfo.phone":"手機",
		"userInfo.datorErrText[7]":"只能輸入中文、英文、空格、數字",
		"userServe.tipsText10":"此操作將停用該服務",
		"userServe.tipsText11":"此操作將啟動該服務",
		"nav.text8":"個人資料",
		"nav.text9":"註冊成功",
		"userInfo.email":"電郵",
		"userInfo.formLabel[2]":"修改密碼",
		"userInfo.rulesName":"手機號不能為空",
		"userInfo.close":"關",
		"ui.placeholderPassword4":"密碼必須同時包括字母及數字",
		"userServe.tipsText12":"修改成功",
		"register.placeholdeSrubPromoCode":"輸入優惠碼(選項)",
		"userServe.tipsText13":"未啟動服務",
		"userInfo.datorErrText[6]":"只能輸入中文、英文、空格",
		"ui.placeholderPassword3":"兩次輸入密碼不一致",
		"ui.placeholderPassword2":"請輸入密碼",
		"register.rulesCode":"驗證碼不能為空",
		"userInfo.operationSuccess":"操作成功",
		"userInfo.formLabel[1]":"昵稱",
		"login.placeholderLogin2":"請輸入電郵和密碼",
		"userInfo.closeServe":"已關閉服務狀態",
		"login.placeholderLogin":"請輸入手機號碼和密碼",
		"nav.text2":"忘記密碼",
		"forgetPassword.placeholderPassword":"請輸入密碼",
		"nav.text3":"新會員註冊",
		"register.privacyText":"私隱條款",
		"nav.text1":"會員登入",
		"nav.text6":"綁定手機",
		"nav.text7":"第三方綁定",
		"userInfo.stopButton2":"申請停用",
		"nav.text4":"條款",
		"nav.text5":"綁定電郵",
		"err.tipsText1":"返回會員官網",
		"register.loginText":"登入已有帳戶",
		"err.tipsText5":"開通並登錄",
		"userInfo.stopButton":"停用/刪除會籍",
		"err.tipsText4":"提示",
		"err.tipsText3":"當前賬戶未開通該服務",
		"forgetPassword.submit":"確定",
		"err.tipsText2":"加載中",
		"forgetPassword.placeholderLoginName2":"請輸入電子郵件地址",
		"userInfo.formLabel[0]":"姓名",
		"forgetPassword.placeholderLoginName":"請輸入手機號碼",
		"forgetPassword.tablName1":"手提電話賬號",
		"forgetPassword.tablName2":"電郵賬號",
		"userInfo.alter":"修改",
		"register.password":"密碼",
		"registerResult.tipsText4":"已開通服務平台",
		"registerResult.tipsText3":"我們將努力為閣下提供文化閱讀體驗。",
		"register.forgetPassword":"修改密碼",
		"register.regSuccess":"立即體驗服務",
		"login.subTitle":"一本 – 文化閱讀購物平台",
		"forgetPassword.getCodeText2":"{count}秒後可重發",
		"userData.tipsText79":"提交申請成功",
		"forgetPassword.placeholderOldPassword":"請輸入舊密碼",
		"register.tablName1":"手提電話註冊",
		"register.tablName2":"電郵註冊",
		"ui.placeholderEmail3":"請輸入正確的電郵地址",
		"userInfo.serveTips":"此操作將停用該服務",
		"login.newUser":"新會員加入",
		"userInfo.gender[1]":"女",
		"register.getCodeText2":"{count}秒後可重發",
		"ui.placeholderEmail2":"請輸入電郵",
		"userData.tipsText80":"停用成功",
		"userData.tipsText81":"解除綁定",
		"ui.886":"+886 中國台灣",
		"register.rules2":"本人同意接收有關「SUPer Card」、「{count}」之最新產品資訊、折扣優惠推薦、促銷通訊或任何類似的訊息。",
		"forgetPassword.placeholderPassword2":"重新輸入密碼",
		"register.rules3":"本人同意接收有關「SUPer Card」之最新產品資訊、折扣優惠推薦、促銷通訊或任何類似的訊息。",
		"ui.placeholderEmail":"請輸入電子郵件地址",
		"register.merchant":"聯營商戶",
		"login.placeholderLoginName":"請輸入手機號碼",
		"userData.tipsText68":"停用",
		"register.tipsText18":"本人已閱讀及同意「SUPer Card」 會員條款、細則及 私隱條款，並同意啟動「一本MyBookOne」服務接受其 條款細則及私隱條款。",
		"register.tipsText17":"業務介紹",
		"register.title":"一個SUPer Card帳戶， 體驗文化閱讀生活",
		"userData.tipsText69":"刪除",
		"register.tipsText16":"私隱條款聲明",
		"forgetPassword.textTips1":"找回密碼",
		"register.tipsText15":"條款及細則",
		"nav.text14":"申請刪除賬號",
		"register.tipsText14":"有關SUPer Card",
		"nav.text13":"會籍二維碼",
		"register.tipsText13":"優惠碼錯誤",
		"nav.text12":"會員會籍",
		"register.tipsText12":"關閉",
		"nav.text11":"服務管理",
		"register.tipsText11":"接收推廣優惠資訊",
		"forgetPassword.rulesName":"賬號不能為空",
		"nav.text10":"註冊服務",
		"register.termsText":"條款細則",
		"forgetPassword.placeholderCode":"請輸入驗證碼",
		"ui.placeholderCode2":"獲取驗證碼",
		"ui.placeholderCode3":"{count}秒後可重發",
		"userInfo.gender[0]":"男",
		"userData.tipsText70":"接收驗證碼",
		"register.tipsText10":"啟動服務",
		"userData.tipsText71":"手提電話",
		"userData.tipsText72":"電郵",
		"userData.tipsText73":"申請原因",
		"userData.tipsText74":"請輸入申請原因",
		"userData.tipsText75":"停用後，會員服務將無法使用",
		"login.rulesPassword":"密碼不能為空",
		"userData.tipsText76":"一經刪除，帳戶內所有資料將無法恢復",
		"userData.tipsText77":"確認申請刪除會籍",
		"userData.tipsText78":"確認停用會籍",
		"userData.tipsText57":"去綁定",
		"userData.tipsText58":"第三方綁定服務已關閉",
		"userData.tipsText59":"第三方綁定中",
		"login.tablName1":"手提電話登入",
		"login.tablName2":"電郵登入",
		"register.submit":"註冊",
		"userInfo.formLabel[10]":"會員編號",
		"userInfo.placeholder[3]":"不可修改",
		"userInfo.datorErrText[1]":"請輸入兩個以上字符",
		"forgetPassword.placeholderNewPassword":"請輸入新密碼",
		"register.placeholderSubPromoCode":"輸入優惠碼(選項)",
		"login.forgetText":"忘記密碼",
		"register.subTitle":"歡迎閣下登記成為SUPer Card會員，</br> 並開通「{count}」服務平台。",
		"userData.tipsText60":"確認解綁嗎？",
		"login.loginButtonText2":"正在登入中",
		"userData.tipsText61":"解綁成功",
		"userData.tipsText62":"請選擇性別",
		"userData.tipsText63":"請選擇生日",
		"register.save":"保存",
		"userData.tipsText64":"取消",
		"userData.tipsText65":"居住地",
		"userData.tipsText66":"請輸入居住地",
		"userData.tipsText67":"類型",
		"register.placeholder":"請剔選同意以上條款",
		"userData.tipsText46":"確認新密碼",
		"userData.tipsText47":"請輸入新密碼",
		"userData.tipsText48":"修改",
		"userData.tipsText49":"密碼必須為英文與數字組合",
		"register.nextStep":"下一步",
		"userInfo.placeholder[4]":"請選擇日期",
		"forgetPassword.loginName":"賬號",
		"register.tabText2":"電郵註冊",
		"userInfo.datorErrText[0]":"姓名不能存在數字",
		"ui.placeholderPassword":"請輸入密碼",
		"register.rulesName":"賬號不能為空",
		"login.deleSuccess":"刪除成功",
		"userInfo.serveRules2":"私隱條款",
		"userData.tipsText50":"請輸入兩個以上英文與數字",
		"userInfo.serveRules1":"服務細則",
		"userData.tipsText51":"最多輸入12個字符",
		"userInfo.serveRules4":"服務細則",
		"userData.tipsText52":"密碼包含特殊字符",
		"userInfo.serveRules3":"服務條款",
		"userData.tipsText53":"兩次輸入不一致",
		"deleteAccount.tipsText12":"一經刪除，帳戶內所有資料將無法恢復",
		"userData.tipsText54":"新舊密碼不可一致",
		"userInfo.change":"更換",
		"deleteAccount.tipsText13":"提交申請成功",
		"userData.tipsText55":"修改密碼成功",
		"deleteAccount.tipsText10":"請閱讀說明並且勾選",
		"userData.tipsText56":"已綁定，點擊解綁",
		"deleteAccount.tipsText11":"提示",
		"login.rulesName":"賬號不能為空",
		"userData.tipsText35":"驗證碼已經發送到你電郵,請註意查收",
		"userData.tipsText36":"驗證碼格式不正確",
		"userData.tipsText37":"系統會於60秒後再發送",
		"userData.tipsText38":"手機號碼必須爲數字",
		"userInfo.placeholder[1]":"請輸入姓名",
		"register.placeholderCode":"輸入驗證碼",
		"userData.tipsText39":"請輸入正確的8位數手機號碼",
		"forgetPassword.getCodeText":"獲取驗證碼",
		"forgetPassword.placeholderNewPassword2":"重新輸入新密碼",
		"userData.tipsText40":"請輸入正確的11位數手機號碼",
		"register.doRegister":"註冊",
		"userData.tipsText41":"驗證碼已發送",
		"userData.tipsText42":"密碼",
		"userInfo.unvalidated":"未驗證",
		"userData.tipsText43":"請輸入舊密碼",
		"userData.tipsText44":"新密碼",
		"userData.tipsText45":"請輸入新密碼",
		"login.tipsText5":"己登入裝置",
		"userData.tipsText24":"生日只能填寫一次",
		"registerResult.tipsText2":"恭喜，閣下已成功完成登記，",
		"login.tipsText4":"您的會員帳號已綁定下列装置，因此無法於此裝置登入。如需重設，請與客戶服務部聯絡。",
		"userData.tipsText25":"不可為空",
		"userInfo.formLabel[9]":"頭像",
		"registerResult.tipsText1":"完成註冊",
		"login.tipsText3":"您的會員帳號已於下列裝置登入，如選擇於此裝置繼續登入，下列裝置將會被強制登出。",
		"userData.tipsText26":"請輸入姓名",
		"userInfo.placeholder[2]":"請輸入暱稱",
		"login.tipsText2":"裝置綁定",
		"userData.tipsText27":"請輸入兩個以上字符",
		"login.tipsText9":"第三方登錄中",
		"userData.tipsText28":"最多輸入25個字符",
		"login.placeholderLoginName2":"請輸入電子郵件地址",
		"login.tipsText8":"於{count}登入",
		"userData.tipsText29":"只能輸入中文、英文、空格",
		"login.tipsText7":"繼續於此裝置登入",
		"login.tipsText6":"巳綁定裝置",
		"login.tipsText1":"帳號已於其他裝置登入",
		"login.otherType":"更多登入方式",
		"userData.tipsText7":"修改密碼",
		"userData.tipsText6":"手機號碼",
		"userData.tipsText9":"綁定後可使用第三方帳號快捷登錄本帳號",
		"forgetPassword.success":"密碼重置成功",
		"userData.tipsText8":"第三方帳號",
		"ui.853":"+853 澳門特別行政區",
		"userData.tipsText1":"會員編號",
		"userData.tipsText30":"更新成功",
		"userData.tipsText3":"暱稱",
		"userData.tipsText31":"請輸入暱稱",
		"userData.tipsText2":"頭像",
		"userData.tipsText32":"由2-25個中英文組成",
		"userData.tipsText5":"未驗證",
		"userData.tipsText33":"請輸入你的電郵",
		"userInfo.title2":"聯營服務",
		"ui.852":"+852 香港特別行政區",
		"userData.tipsText4":"電郵",
		"userData.tipsText34":"確認",
		"userInfo.title1":"會籍資訊",
		"login.captchaText":"請按住滑塊，拖動到最右邊",

		"form.confirmBtn": "确定",
		"form.cancelBtn": "取消",
	}
}